import { BIN_SIZE_TO_LABEL } from "@/constants/warehouse"
import type { ProductShelvingRequirementBinSize, WarehouseArea, WarehouseShelving } from "@/graphql/codegen/graphql"
import type { AutocompleteOption, SelectOption } from "@/types/form-fields"

export const getProductShelvingRequirementsBinSizeLabel = (
  binSize: ProductShelvingRequirementBinSize | string
): string => BIN_SIZE_TO_LABEL[binSize] ?? binSize

export const getWarehouseOptions = (warehouses: WarehouseArea[]): AutocompleteOption<string>[] => {
  return warehouses
    .map(
      (warehouse) =>
        ({
          id: warehouse.warehouseAreaId,
          label: `${warehouse.externalSystemId} ${warehouse.location?.description}`,
        }) as AutocompleteOption<string>
    )
    .sort((a, b) => a.label.localeCompare(b.label))
}

export const getWarehouseShelvingLocationOptions = (warehouseShelvings: WarehouseShelving[]): SelectOption[] => {
  const uniqueLocationCodes = new Set(warehouseShelvings.map(({ code }) => code).filter(Boolean) as string[])
  return [...uniqueLocationCodes]
    .sort((a, b) => a.localeCompare(b))
    .map((location) => ({ value: location, label: location }))
}

export const getWarehouseShelvingAisleOptions = (
  warehouseShelvings: WarehouseShelving[],
  selectedLocationCode: string
): SelectOption[] => {
  const uniqueAisleCodes = new Set(
    warehouseShelvings
      .filter(({ code }) => code === selectedLocationCode)
      .map(({ aisleCode }) => aisleCode)
      .filter(Boolean) as string[]
  )
  return [...uniqueAisleCodes]
    .sort((a, b) => Number(a) - Number(b))
    .map((value) => ({ value: value, label: value }) as SelectOption)
}
